var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 25,
    viewBox: "0 0 90 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 0H85C87.7614 0 90 2.23858 90 5V20C90 22.7614 87.7614 25 85 25H45V0Z",
    fill: "#D1F27A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23858 2.23858 0 5 0H45V25H5C2.23858 25 0 22.7614 0 20V5Z",
    fill: "#F1F5F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchButton);
export default __webpack_public_path__ + "static/media/Switch_button.ac2041f2a0dafbb6607fff0e78c8a0ba.svg";
export { ForwardRef as ReactComponent };